const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';
const revealMotionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
const revealObservers = new Set();

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const elements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  if (!elements.length) return;
  if (revealMotionPreference.matches || isDesignModeEvent || !('IntersectionObserver' in window)) {
    elements.forEach(element => {
      element.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.classList.add(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    });
    return;
  }
  let remaining = elements.length;
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        observer.unobserve(entry.target);
        if (--remaining === 0) { observer.disconnect(); revealObservers.delete(observer); }
      } else {
        entry.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      }
    });
  }, { rootMargin: '0px 0px -24px 0px' });
  revealObservers.add(observer);
  elements.forEach(element => observer.observe(element));
}

function cancelRevealsForReducedMotion() {
  if (!revealMotionPreference.matches) return;
  revealObservers.forEach(observer => observer.disconnect());
  revealObservers.clear();
  initializeScrollAnimationTrigger();
}
if (revealMotionPreference.addEventListener) revealMotionPreference.addEventListener('change', cancelRevealsForReducedMotion);
else revealMotionPreference.addListener(cancelRevealsForReducedMotion);
window.addEventListener('DOMContentLoaded', () => initializeScrollAnimationTrigger());
if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', event => initializeScrollAnimationTrigger(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}
